<template>
    <v-dialog
        :fullscreen="fullscreen"
        :persistent="persistent"
        overlay-opacity="0.8"
        :scrollable="scrollable"
        :max-width="maxWidth"
        :transition="fullscreen ? 'dialog-bottom-transition' : undefined"
        v-model="dialog"
    >
        <slot></slot>
    </v-dialog>
</template>

<script>
export default {
    name: "BaseDialog",
    data() {
        return {
            dialog: false,
        }
    },
    props: {
        scrollable: {
            type: Boolean,
            default: true,
        },
        persistent: {
            type: Boolean,
            default: false,
        },
        fullscreen: {
            type: Boolean,
            default: false,
        },
        maxWidth: {
            default: 450
        },
        closeOnBack: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        show() {
            if (this.closeOnBack) {
                this.$router.push({...this.$route, hash: '#dialog'}).catch(() => {
                })
            }
            this.dialog = true;
        },
        hide() {
            this.dialog = false;
        }
    },
    watch: {
        dialog(show) {
            if (!show && this.closeOnBack) {
                this.$router.push({...this.$route, hash: ''}).catch(() => {
                })
            }
        }
    },
    created() {
        if (this.closeOnBack) {
            if (!this.dialog && this.$route.hash === '#dialog') {
                this.$router.replace({...this.$route, hash: ''}).catch(() => {
                })
            }
            this.$router.afterEach(() => {
                if (this.$route.hash !== '#dialog') {
                    this.dialog = false;
                }
            })
        }
    }
}
</script>